/** Mirrors DEFAULT_BETA_FIRST_CHARGE_AT on the server; the server sends the real date and this is only the fallback. */
export const DEFAULT_FIRST_CHARGE_AT = '2027-01-01T00:00:00-06:00';

/** "January 1, 2027": billing dates are read in US Central time, the same zone the first charge is defined in. */
export function formatFirstChargeDate(value?: string | Date | null): string {
  const date = new Date(value ?? DEFAULT_FIRST_CHARGE_AT);
  return date.toLocaleDateString('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'long', day: 'numeric' });
}

export function cardSavedCopy(firstChargeAt?: string | Date | null): string {
  return `Your card is saved. You won't be charged until ${formatFirstChargeDate(firstChargeAt)}.`;
}
export function foundingRateLockCopy(firstChargeAt?: string | Date | null): string {
  return `Your first charge is on ${formatFirstChargeDate(firstChargeAt)}, then $80 per user per month. Every firm user is a paid seat.`;
}
export function betaCardBannerCopy(firstChargeAt?: string | Date | null): string {
  return `Add a card to keep ClaimHive after your free beta. You won't be charged until ${formatFirstChargeDate(firstChargeAt)}.`;
}
export const PAID_USER_PRICE_COPY = '$80 per user per month';
export const PLATFORM_NAME = 'ClaimHive';
